import { Button } from '@consta/uikit/Button'
import { Layout } from '@consta/uikit/Layout'
import type { FC } from 'react'

import css from './AddingFilesModal.css'
import type { AddingFilesModalFooterPropsType as PropsType } from './types'

const AddingFilesModalFooter: FC<PropsType> = ({
  isViewSaveAllBtn,
  isDisabledOnSaveBtn,
  onCancel,
  onSave,
  onSaveForAll,
}) => {
  return (
    <Layout className={css.footer}>
      <Layout flex={1}>
        <Button
          size="s"
          view="ghost"
          label="Отменить"
          width="default"
          className={css.footerBtn}
          onClick={onCancel}
        />
      </Layout>

      {!!isViewSaveAllBtn && (
        <Button
          className={css.footerBtn}
          size="s"
          view="secondary"
          label="Применить для всех"
          width="default"
          disabled={isDisabledOnSaveBtn}
          onClick={onSaveForAll}
        />
      )}

      <Button
        size="s"
        view="primary"
        label="Применить"
        width="default"
        disabled={isDisabledOnSaveBtn}
        onClick={onSave}
      />
    </Layout>
  )
}

export { AddingFilesModalFooter }
